import React, { useMemo, useState, useEffect } from 'react';
import ContentTypgraphy from 'components/Common/ContentTypography';
import HeaderTypgraphy from 'components/Common/HeaderTypography';
import TitleBar from 'components/Common/TitleBar';
import { useHistory } from 'react-router-dom';
import ClickableDiv from 'components/Common/ClickableDiv';
import Ad, { Statuses as AdStatuses } from 'models/business/Ad';
// import Market from 'models/business/Market';
import useModelConvenience from 'components/hooks/useModelConvenience';
import API from 'api';
import AdCarBar from './AdCardBar';

import Styles from './index.module.css';

const steps = [
  '我的廣告',
  '新增廣告單元',
];

function SelectOptionStep() {
  const history = useHistory();
  const { fullyPopulateMarket } = useModelConvenience();
  const [ads, setAds] = useState([]);

  const getAdList = async () => {
    // const result = await API.ad.postAdList();
    const result = await API.ad.postAdList2();
    if (result.error) {
      alert(result.error.errorMsg);
      return result.error;
    }
    setAds((result.resultData || []).map((ad) => new Ad(ad)));
    return null;
  };

  const prepareAdForDuplication = async (ad) => {
    const newAd = ad.clone();
    const success = await fullyPopulateMarket(newAd);
    if (!success) return null;
    newAd.startDate = ad.earliestStartingDate;
    newAd.status = AdStatuses.Incomplete;
    return newAd;
  };

  // eslint-disable-next-line no-unused-vars
  const createDuplicateAd = async (ad) => {
    const newAd = ad.clone();
    const success = await fullyPopulateMarket(newAd);
    if (!success) return null;
    newAd.startDate = ad.earliestStartingDate;
    newAd.status = AdStatuses.Incomplete;
    // const result = await API.ad.postNewAd(newAd.toNewJSON());
    const result = await API.ad.postNewAd2(newAd.toNewJSON());
    if (result.error) {
      alert(result.error.errorMsg);
      return null;
    }
    const referenceAd = new Ad(result.resultData);
    newAd.id = referenceAd.id;
    return newAd;
  };

  const handleDuplicateAd = async (ad) => {
    const newAd = await prepareAdForDuplication(ad);
    if (!newAd) return;
    history.push('/AdSetting', { ad: newAd });
  };

  // const handleDuplicateAd = async (ad) => {
  //   const newAd = await createDuplicateAd(ad);
  //   if (!newAd) return;
  //   if (newAd.isGoogle) history.push('/GoogleResourceSetting', { ad: newAd, firstEdit: true });
  //   else if (newAd.isFacebook)history.push('/FbResourceSetting', { ad: newAd, firstEdit: true });
  // };

  const renderAdCards = useMemo(() => (
    ads.map((ad) => (
      <div
        key={ad.id}
        style={{
          marginBottom: '6px',
        }}
      >
        <AdCarBar
          ad={ad}
          onClick={() => handleDuplicateAd(ad)}
        />
      </div>
    ))
  ), [ads]);

  useEffect(() => {
    getAdList();
  }, []);

  return (
    <div className={Styles.container}>
      <div
        className={Styles.midCol}
      >
        <div
          style={{
            marginBottom: '44px',
          }}
        >
          <TitleBar steps={steps} />
        </div>
        <div
          className={Styles.titleBar}
        >
          <HeaderTypgraphy>新增廣告單元</HeaderTypgraphy>
        </div>
        <ClickableDiv
          onClick={() => history.push('/AdSetting')}
          className={Styles.newAdButton}
        >
          <HeaderTypgraphy>創建全新的廣告</HeaderTypgraphy>
        </ClickableDiv>
        <div
          className={Styles.saparateWord}
        >
          <ContentTypgraphy>或</ContentTypgraphy>
        </div>
        <div
          className={Styles.titleBar}
        >
          <HeaderTypgraphy>複製原有的廣告</HeaderTypgraphy>
        </div>
        {renderAdCards}
      </div>
    </div>
  );
}

export default SelectOptionStep;
